import { InjectionToken } from '@angular/core';
import { ClientInfo } from '../models/client-info.model';

export const CLIENT_INFO = new InjectionToken<ClientInfo>('CLIENT_INFO');
